export var JobRole;
(function (JobRole) {
    JobRole[JobRole["Admin"] = 0] = "Admin";
    JobRole[JobRole["Manager"] = 1] = "Manager";
    JobRole[JobRole["TeamMember"] = 2] = "TeamMember";
})(JobRole || (JobRole = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiam9iLXJvbGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJqb2Itcm9sZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxPQUlYO0FBSkQsV0FBWSxPQUFPO0lBQ2YsdUNBQVMsQ0FBQTtJQUNULDJDQUFXLENBQUE7SUFDWCxpREFBYyxDQUFBO0FBQ2xCLENBQUMsRUFKVyxPQUFPLEtBQVAsT0FBTyxRQUlsQiJ9